import script from "./AppFieldLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFieldLabel.vue?vue&type=script&setup=true&lang=ts"

import "./AppFieldLabel.vue?vue&type=style&index=0&id=45e67ab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e67ab4"]])

export default __exports__